var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_10472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6644 7.49821C11.6644 7.94015 11.4888 8.36399 11.1763 8.67649C10.8638 8.98899 10.44 9.16455 9.99805 9.16455H4.99903L1.66634 12.4972V3.33236C1.66634 2.89042 1.8419 2.46658 2.1544 2.15408C2.4669 1.84158 2.89074 1.66602 3.33268 1.66602H9.99805C10.44 1.66602 10.8638 1.84158 11.1763 2.15408C11.4888 2.46658 11.6644 2.89042 11.6644 3.33236V7.49821Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9971 7.49902H16.6634C17.1054 7.49902 17.5292 7.67458 17.8417 7.98708C18.1542 8.29958 18.3298 8.72342 18.3298 9.16537V18.3302L14.9971 14.9976H9.99805C9.55611 14.9976 9.13227 14.822 8.81977 14.5095C8.50727 14.197 8.33171 13.7732 8.33171 13.3312V12.498",
    stroke: "#D1D5DC",
    strokeWidth: 1.66634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_10472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9961,
    height: 19.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.e6f0c2b0d13d41a56fa673b2b8a81845.svg";
export { ForwardRef as ReactComponent };